import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileUp, Loader2, FileCheck } from "lucide-react";
import { API, authHeaders, formatApiError } from "./AdminPage";
import { useAdminT } from "./adminI18n";

export const FileField = ({ label, value, onChange, testid }) => {
  const { t } = useAdminT();
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const data = new FormData();
      data.append("file", file);
      const res = await axios.post(`${API}/admin/files/upload`, data, { headers: authHeaders() });
      onChange(res.data.id);
      toast.success(t("تم رفع الملف"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid={testid}>
      <label className="block text-sm text-luxury-gray mb-2">{label}</label>
      <div className="flex items-center gap-4 flex-wrap">
        <label
          data-testid={testid ? `${testid}-upload` : undefined}
          className="flex items-center gap-2 border border-luxury-border text-luxury-gold px-4 py-2.5 rounded-full text-sm cursor-pointer hover:border-luxury-gold transition-colors"
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : value ? <FileCheck className="w-4 h-4" strokeWidth={1.5} /> : <FileUp className="w-4 h-4" strokeWidth={1.5} />}
          {uploading ? t("جارٍ الرفع...") : value ? t("تم إرفاق الملف — استبدال") : t("رفع ملف (PDF / MP3 / ZIP)")}
          <input type="file" accept=".pdf,.zip,.mp3,.m4a" onChange={upload} className="hidden" />
        </label>
        {value ? <span className="text-luxury-gray text-xs" dir="ltr">ID: {value.slice(0, 8)}…</span> : null}
      </div>
    </div>
  );
};
